// Modules
import { FormattedMessage } from "react-intl";
// Material-UI
import { Grid, TextField } from "@mui/material";
// Helpers
import {
    FREQ_DAILY,
    FREQ_EVERYXWEEKS,
    FREQ_MONTHLY,
    FREQ_NONE,
    FREQ_WEEKDAYS,
    FREQ_WEEKLY
} from "../../../../../helpers/constants";

export const RECURRENCE = {
    [FREQ_NONE]: {
        props: {
            freq: FREQ_NONE,
            byweekday: undefined
        }
    },
    [FREQ_DAILY]: {
        props: {
            freq: FREQ_DAILY,
            byweekday: undefined
        }
    },
    [FREQ_WEEKDAYS]: {
        props: {
            freq: FREQ_WEEKLY,
            byweekday: ["MO", "TU", "WE", "TH", "FR"]
        }
    },
    [FREQ_WEEKLY]: {
        props: {
            freq: FREQ_WEEKLY,
            byweekday: undefined
        }
    },
    [FREQ_EVERYXWEEKS]: {
        getLabel: ({ values, getFieldProps, setFieldValue }) => (
            <Grid container spacing={1} alignItems="center">
                <Grid item>
                    <FormattedMessage id="every" />
                </Grid>
                <Grid item>
                    <TextField
                        disabled={values.recurrence !== FREQ_EVERYXWEEKS}
                        type="number"
                        inputProps={{
                            min: "1",
                            max: "48"
                        }}
                        {...getFieldProps("rrule.interval")}
                        value={values.rrule?.interval || 1}
                        onChange={e => {
                            const value = e.target.value?.trim();
                            if (["", ...Array.from({ length: 48 }, (_, i) => `${i + 1}`)].includes(value)) {
                                setFieldValue("rrule.interval", value?.length > 0 ? Number.parseInt(value) : value);
                            }
                        }}
                        sx={{ width: "70px" }}
                    />
                </Grid>
                <Grid item>
                    <FormattedMessage id="weeks" />
                </Grid>
            </Grid>
        ),
        hasCustomInterval: true,
        props: {
            freq: FREQ_WEEKLY,
            byweekday: undefined
        }
    },
    [FREQ_MONTHLY]: {
        props: {
            freq: FREQ_MONTHLY,
            byweekday: undefined
        }
    }
};
